import { render } from "./BaoCaoSanLocBenhKLNVaKSK.vue?vue&type=template&id=786c3c7a&ts=true"
import script from "./BaoCaoSanLocBenhKLNVaKSK.vue?vue&type=script&lang=ts"
export * from "./BaoCaoSanLocBenhKLNVaKSK.vue?vue&type=script&lang=ts"

import "./BaoCaoSanLocBenhKLNVaKSK.vue?vue&type=style&index=0&id=786c3c7a&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__